<template>
  <div class="top-menu-wrapper">
    <div class="content-width-1300">
      <div class="top-menu-left">
        <img class="cursor" @click="$router.push('/home-page')" src="../../assets/xiaoshan-logo.png" alt />
      </div>
      <div class="top-menu-box">
        <div class="nav-menu" id="topNavMenu">
          <div
            v-for="(menu, index) in menuList"
            :key="index"
            :name="index"
            :class="{
              'menu-item': true,
              'select-menu': $route.path.indexOf(menu.haveIndexOf) !== -1 || isSelect === index
            }"
            @click="routerChange(menu, index)"
            @mouseenter="_mouseEnter(menu, index, $event)"
            @mouseleave="_mouseLeave(menu, index, $event)"
          >
            {{ menu.title }}
          </div>
        </div>
        <div v-if="false" class="menu-active-bar" id="menuActiveBar"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { productType } from "config/config";
import { mapState } from 'vuex';
import {
  preventRepeatMessage
} from "utils/util";
// import { setAuthority } from "utils/menuList.js";
export default {
  name: "TopMenu",
  data() {
    return {
      isSelect: null,
      menuList: [
        {
          title: "首页",
          path: "/",
          module: "HOME",
          haveIndexOf: "/home"
        },
        {
          title: "同步课程",
          path: "/synchronous-courses",
          module: "SYNCHRONOUS_COURSES",
          haveIndexOf: "/synchronous-courses"
        },
        {
          title: "专题课程",
          path: "/topic-classes",
          module: "TOPIC_CLASSES",
          haveIndexOf: "/topic-classes"
        },
        {
          title: "试卷库",
          path: "/examination",
          module: "EXAMINATION",
          haveIndexOf: "/examination"
        },
        {
          title: "直播课堂",
          path: "/live-course",
          module: "LIVE_COURSE",
          haveIndexOf: "/live-course"
        },
         {
          title: "我的任务",
          path: "/my-task/list",
          icon: "iconwoderenwu",
          module: "STUDENT_MY_TASK",
          haveIndexOf: "/my-task"
        }
      ],
      leaveTime: null,
      isEnter: true,
      productType: 1
    };
  },
  computed: {
    ...mapState(['isLogin'])
  },
  watch: {
    $route: {
      immediate: true,
      handler(val, oldVal) {
        setTimeout(() => {
          let fullPath = val.fullPath;
          if(fullPath.indexOf('/my-task') !== -1) {
            this._setSelectIndex('/my-task');
          }else if(fullPath.indexOf('/live-course') !== -1) {
            this._setSelectIndex('/live-course');
          }else if(fullPath.indexOf('/topic-classes') !== -1 || (fullPath.indexOf('/resource-detail') !== -1 && fullPath.indexOf('type=topic') !== -1)) {
            this._setSelectIndex('/topic-classes');
          }else if(fullPath.indexOf('/examination') !== -1 || (fullPath.indexOf('/resource-detail') !== -1 && fullPath.indexOf('type=examination') !== -1)) {
            this._setSelectIndex('/examination');
          }else if(fullPath.indexOf('/synchronous-courses') !== -1 || fullPath.indexOf('/play') !== -1) {
            this._setSelectIndex('/synchronous-courses');
          }else if(fullPath.indexOf('/home') !== -1 || fullPath === '/') {
            this._setSelectIndex('/home');
          }else {
            this.isSelect = null;
          }
          this._activeChange(this.isSelect);
        }, 100);
      }
    },
  },
  methods: {
    routerChange(item, index) {
      if(!this.isLogin && item.path === '/my-task/list') {
        // preventRepeatMessage('warning', '', '请先登录');
        // return;
      }
      this.isSelect = index;
      this.$router.push(item.path);
      // this._activeChange(this.isSelect);
    },
    _setSelectIndex(val) {
      let i = this.menuList.findIndex(ele => ele.haveIndexOf === val);
      if(i !== -1) {
        this.isSelect = i;
      }else {
        this.isSelect = null;
      }
    },
    _mouseEnter(item, index, e) {
      // console.log('---enter', e.target)
      this.isEnter = true;;
      // this._activeChange(index);
      
    },
    _mouseLeave(item, index, e) {
      // console.log('leave---', e.target);
      this.isEnter = false;
      return;
      let leaveTime = setTimeout(() => {
        clearTimeout(leaveTime);
        leaveTime = null;
        if(!this.isEnter) {
          this._activeChange(this.isSelect);
        }
      }, 100);

    },
    _activeChange(index) {
      this.$nextTick(() => {
        if(index === null) {
          $('#menuActiveBar').css({
            width: '0px',
            transform: `translateX(0px)`
          });
          return;
        }
        let _boxLeft = $('#topNavMenu').offset().left;
        let _selectEle = $('#topNavMenu .menu-item').eq(index);
        let _selectWidth = _selectEle.width();
        let _selectPaddingL = _selectEle.css('paddingLeft');
        _selectPaddingL = _selectPaddingL.replace('px', '');
        if(!isNaN(_selectPaddingL)) {
          _selectPaddingL = Number(_selectPaddingL);
        }else {
          _selectPaddingL = 0;
        }
        let _selectLeft = _selectEle.offset().left;
        let _diff = _selectLeft - _boxLeft;
        $('#menuActiveBar').css({
          width: _selectWidth - 4 + 'px',
          transform: `translateX(${_diff + _selectPaddingL + 4 / 2}px)`
        });
      });
    }
  },
  created() {
    if (isNaN(productType)) {
      this.productType = 1;
    } else {
      this.productType = Number(productType);
    }
    if(this.productType === 2) {
      this.menuList.splice(5,1);
      // this.menuList.splice(4,1);
      // this.menuList.splice(3,1);
    }else if(this.productType === 3) {
      this.menuList.splice(1,4);
      // this.menuList.splice(1,3);
      // this.menuList.splice(1,2);
    }
    console.log(productType, this.productType);
    // this.menuList = setAuthority(this.menuList);
  },
  mounted() {
    // this._activeChange(this.isSelect);
  }
};
</script>
<style lang="less">
@color-main: #03B2B2;
.top-menu-wrapper {
  width: 100%;
  height: 62px;
  line-height: 62px;
  background: @color-main;
  position: relative;
  z-index: 10;
  .content-width-1300 {
    height: 100%;

    .top-menu-left {
      float: left;
      height: 62px;
      img {
        height: 34px;
        margin-top: 14px;
      }
    }
    .top-menu-box {
      float: left;
      position: relative;
      margin-left: 140px;
      .menu-active-bar {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 3px;
        background: @color-main;
        transform: translateX(42px);
        transition: transform .3s cubic-bezier(.645,.045,.355,1),-webkit-transform .3s cubic-bezier(.645,.045,.355,1);
  
      }
      .nav-menu {
        .menu-item {
          display: inline-block;
          min-width: 88px;
          text-align: center;
          height: 62px;
          line-height: 62px;
          font-size: 16px;
          padding: 0 20px;
          margin: 0 15px;
          color: #fff;
          cursor: pointer;
          .iconfont {
            font-size: 16px;
            padding-right: 10px;
          }
          // &+.menu-item {
          //   margin-left: 84px;
          // }
          &.select-menu {
            color: #00A0A0;
            background: #EBF7F7;
            font-weight: bold;
            // text-shadow: 0 0 1px @color-main;
            position: relative;
            .iconfont {
              color: @color-main;
              font-weight: normal;
            }
          }
          &:hover {
            color: @color-main;
            background: #EBF7F7;
          }
        }
      }
    }
  }
}
</style>